import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanSwitch = () => {
  const handleSuccess = (result) => {
    console.log('Switch data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving Switch data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="switch"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanSwitch;
